<nav class="navbar navbar-expand-lg navigation fixed-top sticky" (window:scroll)="windowScroll()" id="navbar">
    <div class="container">
        <a class="navbar-logo" routerLink="/home">
            <img src="assets/images/logo.png" alt="" height="55" class="logo logo-dark">
            <img src="assets/images/logo.png" alt="" height="60" class="logo logo-light">
        </a>

        <button type="button" class="btn btn-sm px-3 font-size-16 d-lg-none header-item" data-toggle="collapse" 
            data-target="#topnav-menu-content" (click)="toggleMenu()">
            <i class="fa fa-fw fa-bars"></i>
        </button>

        <div class="collapse navbar-collapse" id="topnav-menu-content">
            <ul class="navbar-nav ms-auto" id="topnav-menu">
                <li class="nav-item">
                    <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'home'" [ngClass]="{'active':currentSection === 'home'}">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'about'" [ngClass]="{'active':currentSection === 'about'}">About</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'features'" [ngxScrollToOffset]="5" [ngClass]="{'active':currentSection === 'features'}">Features</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'contact'" [ngxScrollToOffset]="5"
                        [ngClass]="{'active':currentSection === 'contact'}">Contact</a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'roadmap'" [ngxScrollToOffset]="5" [ngClass]="{'active':currentSection === 'roadmap'}">Roadmap</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'team'" [ngxScrollToOffset]="5" [ngClass]="{'active':currentSection === 'team'}">Team</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'news'" [ngxScrollToOffset]="5" [ngClass]="{'active':currentSection === 'news'}">News</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'faqs'" [ngClass]="{'active':currentSection === 'faqs'}">FAQs</a>
                </li> -->

            </ul>
            <div class="my-2 ms-lg-2" *ngIf="!isLoggedIn()">
                <a routerLink="/auth/login" class="btn btn-outline-dark w-xs">Sign in</a>
            </div>
            <div class="my-2 ms-lg-2" *ngIf="!isLoggedIn()">
                <a routerLink="/auth/signup" class="btn btn-outline-dark w-xs">Sign up</a>
            </div>
            <div class="my-2 ms-lg-2" *ngIf="isLoggedIn()">
                <a (click)="logout()" class="btn btn-outline-dark w-xs">Signout</a>
            </div>
        </div>
    </div>
</nav>

<div appScrollspy [spiedTags]="['SECTION']" (sectionChange)="onSectionChange($event)">
    <section class="section hero-section bg-ico-hero" id="home">
        <div class=""></div>
        <div class="container">
            <div class="row">
                <div class="text-white-50">
                    <h1 class="text-white text-center">Welcome to Scarce Infotech Solutions</h1>
                    <p class="font-size-14"></p>
                </div>
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </section>
    <!-- hero section end -->

    <!-- currency price section start -->
    <section class="section bg-white p-0">
        <div class="container">
            <div class="currency-price">
                <div class="row">
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="d-flex">
                                    <img class="mx-auto d-block img-fluid" src="assets/images/tally-prime-logo.svg" alt="tally-prime-logo" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="d-flex">
                                    <img class="mx-auto d-block img-fluid" src="assets/images/logo-salesforce.svg" alt="salesforce-logo" width="120px" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="d-flex">
                                    <img class="mx-auto d-block img-fluid" src="assets/images/logo.svg" alt="tally-prime-logo"  width="180px" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end row -->
            </div>
        </div>
        <!-- end container -->
    </section>
    <!-- currency price section end -->


    <!-- about section start -->
    <section class="section pt-4 bg-white" id="about">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-center mb-5">
                        <div class="small-title"></div>
                        <h1>About Us</h1>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-lg-5">

                    <div class="text-muted">
                        <h4></h4>
                        <p class="fs-2" style="text-align: justify;" >We at <strong>Scarce Infotech Solutions</strong> believe in providing the best services to our clients. We are a team of professionals with a wide range of experience and expertise in different domains. We have been working since 2013 and have worked on various projects for different industries and organizations.</p>
                    </div>
                </div>

                <div class="col-lg-6 ms-auto">
                    <div class="mt-4 mt-lg-0">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="card border">
                                    <div class="card-body">
                                        <div class="mb-3 text-center text-primary">
                                            <i class="bx bx-target-lock fs-1"></i>
                                        </div>
                                        <p class="fs-5 text-center">Our main focus is to provide the best possible solutions for our customers and make them successful in achieving their goals. Our main aim is to help you gain more profit from your business by making it more effective and efficient.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="card border mt-lg-5">
                                    <div class="card-body">
                                        <div class="mb-3 text-center text-primary">
                                            <i class="fas fa-hands-helping fs-1"></i>
                                        </div>
                                        <p class="fs-5 text-center"> We offer all-inclusive services including implementation, support, integration and development for TallyPrime and SalesForce. Apart from this we also offer web application development using Angular, React, .NET Core, MVC etc. and Mobile App Developement using Flutter</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end row -->

            <hr class="my-5">

            <div class="row">
                <div class="col-lg-12">
                    <ngx-slick-carousel dir="ltr" class="events navs-carousel" [config]="aboutConfig">
                        <div ngxSlickItem>
                            <div class="item">
                                <div class="client-images">
                                    <img src="assets/images/clients/1.png" alt="client-img" class="mx-auto img-fluid d-block">
                                </div>
                            </div>
                        </div>
                        <div ngxSlickItem>
                            <div class="item">
                                <div class="client-images">
                                    <img src="assets/images/clients/2.png" alt="client-img" class="mx-auto img-fluid d-block">
                                </div>
                            </div>
                        </div>
                        <div ngxSlickItem>
                            <div class="item">
                                <div class="client-images">
                                    <img src="assets/images/clients/3.png" alt="client-img" class="mx-auto img-fluid d-block">
                                </div>
                            </div>
                        </div>
                        <div ngxSlickItem>
                            <div class="item">
                                <div class="client-images">
                                    <img src="assets/images/clients/4.png" alt="client-img" class="mx-auto img-fluid d-block">
                                </div>
                            </div>
                        </div>
                        <div ngxSlickItem>
                            <div class="item">
                                <div class="client-images">
                                    <img src="assets/images/clients/5.png" alt="client-img" class="mx-auto img-fluid d-block">
                                </div>
                            </div>
                        </div>
                        <div ngxSlickItem>
                            <div class="item">
                                <div class="client-images">
                                    <img src="assets/images/clients/6.png" alt="client-img" class="mx-auto img-fluid d-block">
                                </div>
                            </div>
                        </div>
                    </ngx-slick-carousel>
                </div>
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </section>
    <!-- about section end -->

    <!-- Features start -->
    <section class="section" id="features">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-center mb-5">
                        <div class="small-title"></div>
                        <h4>Products</h4>
                    </div>
                </div>
            </div>
            <!-- end row -->

            <div class="row align-items-center pt-4">
                <div class="col-md-6 col-sm-8">
                    <div>
                        <img src="assets/images/tally-prime-logo.svg" alt="" class="img-fluid mx-auto d-block">
                    </div>
                </div>
                <div class="col-md-5 ms-auto">
                    <div class="mt-4 mt-md-auto">
                        <div class="d-flex align-items-center mb-2">
                            <h4 class="mb-0">Tally Prime</h4>
                        </div>
                        <p class="text-muted">
                            TallyPrime helps businesses manage accounting, inventory, credit & cash flow management, banking, cost analysis, taxation, payroll, and other functions. It supports online access to business data through a web browser on any device.
                        </p>
                        <p>
                            TallyPrime is available in 3 versions
                        </p>
                        <div class="text-muted mt-4">
                            <p><i class="mdi mdi-circle-medium text-success me-1"></i>Silver Edition (single-user license)</p>
                            <p><i class="mdi mdi-circle-medium text-success me-1"></i>Gold edition (multiple users on LAN)</p>
                            <p><i class="mdi mdi-circle-medium text-success me-1"></i>Auditor edition (multiple users only for practicing CAs)</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end row -->

            <div class="row align-items-center mt-5 pt-md-5">
                <div class="col-md-5">
                    <div class="mt-4 mt-md-0">
                        <div class="d-flex align-items-center mb-2">
                            <h4 class="mb-0">Salesforce</h4>
                        </div>
                        <p class="text-muted">
                            Salesforce is the world’s #1 customer relationship management (CRM) platform. It help your marketing, sales, commerce, service and IT teams work as one from anywhere — so you can keep your customers happy everywhere.
                        </p>
                        <p>
                            Salesforce unites your marketing, sales, commerce, service, and IT teams from anywhere with Customer 360 — one integrated CRM platform that powers our entire suite of connected apps. With Customer 360, you can focus your employees on what’s important right now: stabilising your business, reopening, and getting back to delivering exceptional customer experiences.
                        </p>
                    </div>
                </div>
                <div class="col-md-6  col-sm-8 ms-md-auto">
                    <div class="mt-4 me-md-0">
                        <img src="assets/images/logo-salesforce.svg" width="225px" alt="salesforce-logo" class="img-fluid mx-auto d-block">
                    </div>
                </div>

            </div>
            <!-- end row -->
            <div class="row align-items-center pt-4">
                <div class="col-md-6 col-sm-8">
                    <div>
                        <img src="assets/images/logo.svg" alt="" class="img-fluid mx-auto d-block">
                    </div>
                </div>
                <div class="col-md-5 ms-auto">
                    <div class="mt-4 mt-md-auto">
                        <div class="d-flex align-items-center mb-2">
                            <h4 class="mb-0">MTE</h4>
                        </div>
                        <p class="text-muted">
                            MTE is your taillor-made SAAS ERP helps businesses manage crm, sales, finance, inventory, taxation, hr, payroll, and other functions. It supports online access to business data through a web browser on any device.
                        </p>
                        <p>
                            MTE is available at per user per month basis
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- end container -->
    </section>
    <!-- Features end -->

     <!-- contact us start -->
     <section class="section bg-white" id="contact">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-center mb-5">
                        <div class="small-title">contact</div>
                        <h4>Contact Us</h4>
                    </div>
                </div>
            </div>
            <!-- end row -->

            <div class="row">
                <div class="col-xl-4 col-sm-6">
                    <div class="blog-box mb-4 mb-xl-0">
                        <div class="position-relative">
                            <img class="mx-auto d-block img-fluid" src="assets/images/tally-prime-logo.svg" alt="tally-prime-logo" />
                        </div>

                        <div class="mt-4 text-muted  text-center">
                            <h2><a href="tel:+91 90226 91240">+91 90226 91240</a></h2>
                            <h5><a href="mailto:sales@scarceinfotech.com">sales&#64;scarceinfotech.com</a></h5>
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-sm-6">
                    <div class="blog-box mb-4 mb-xl-0">

                        <div class="position-relative">
                            <img class="mx-auto d-block img-fluid" src="assets/images/logo-salesforce.svg" alt="salesforce-logo" width="120px" />
                        </div>

                        <div class="mt-4 text-muted  text-center">
                            <h2><a href="tel:+91 93217 88655">+91 93217 88655</a></h2>
                            <h5><a href="mailto:sales@scarceinfotech.com">sales&#64;scarceinfotech.com</a></h5>
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-sm-6">
                    <div class="blog-box mb-4 mb-xl-0">
                        <div class="position-relative">
                            <img class="mx-auto d-block img-fluid" src="assets/images/logo.svg" alt="tally-prime-logo"  width="180px" />
                        </div>

                        <div class="mt-4 text-muted  text-center">
                            <h2><a href="tel:+91 70219 40258">+91 70219 40258</a></h2>
                            <h5><a href="mailto:sales@scarceinfotech.com">sales&#64;scarceinfotech.com</a></h5>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </section>
    <!-- contace us end -->

    <!-- Footer start -->
    <footer class="landing-footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-sm-6">
                    <div class="mb-4 mb-lg-0">
                        <h5 class="mb-3 footer-list-title">Company</h5>
                        <ul class="list-unstyled footer-list-menu">
                            <li>
                                <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'about'" [ngClass]="{'active':currentSection === 'about'}">About Us</a>
                            </li>
                            <li>
                                <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'features'" [ngxScrollToOffset]="5" [ngClass]="{'active':currentSection === 'features'}">Features</a>
                            </li>
                            <li>
                                <a class="nav-link" href="javascript: void(0);" [ngxScrollTo]="'contact'" [ngxScrollToOffset]="5"
                                [ngClass]="{'active':currentSection === 'contact'}">Contact</a>
                            </li>
                            <!-- <li><a href="javascript: void(0);">News</a></li>
                            <li><a href="javascript: void(0);">FAQs</a></li> -->
                        </ul>
                    </div>
                </div>

            </div>
            <!-- end row -->

            <hr class="footer-border my-5">

            <div class="row">
                <div class="col-lg-6">
                    <p class="mb-2">{{year}} © MTE. Design & Develop by Scarce Infotech Solutions</p>
                </div>

            </div>
        </div>
        <!-- end container -->
    </footer>
    <!-- Footer end -->